<template>
  <!-- partial -->
  <div class="page-content">
    <div class="row">
      <div class="col-lg-7 col-md-7 col-sm-6 col-xs-12">
        <h5 class="txt-dark">
          New Documents &nbsp;
          <add-button
            link="/document-management/new-documents/create"
          ></add-button>
        </h5>
      </div>
      <!-- Breadcrumb -->
      <div class="col-lg-5 col-sm-6 col-md-5 col-xs-12">
        <ol class="breadcrumb breadcrumb-line" style="float: right">
          <li class="breadcrumb-item">
            <router-link :to="`/`">Dashboard</router-link>
          </li>
          <li class="breadcrumb-item">Document Management</li>
          <li class="breadcrumb-item">New Documents</li>
          <li class="breadcrumb-item active" aria-current="page">List</li>
        </ol>
      </div>
    </div>
    <!-- /Breadcrumb -->
    <!-- Search & Filtering  -->
    <div class="col-md-12 grid-margin stretch-card">
      <div class="card">
        <div class="card-body">
          <div class="col-lg-8 col-md-8 col-sm-6 col-xs-12">
            <input
              type="text"
              class="form-control"
              placeholder="Search..."
              v-model="searchData"
              @keydown.enter="search"
            />
          </div>
        </div>
      </div>
    </div>
    <!-- Search & Filtering  -->
    <!-- Table -->
    <div class="row">
      <div class="col-md-12 grid-margin stretch-card">
        <div class="card">
          <div class="card-body">
            <!-- Export To Excel -->
            <div class="row">
              <div class="col-md-8"></div>
              <div class="col-md-4">
                <div style="float: right">
                  <a
                    href="#"
                    class="btn btn-primary"
                    v-if="Exportdocuments.length == 0"
                    @click="exportToExcel"
                  >
                    <span v-if="isExcelloading">
                      <div class="d-flex align-items-center">
                        <strong>Generating Excel</strong>
                        &nbsp;
                        <div
                          class="
                            spinner-border
                            text-light
                            spinner-border-sm
                            ms-auto
                          "
                          role="status"
                          aria-hidden="true"
                        ></div>
                      </div>
                    </span>
                    <span v-else>Generate Excel</span>
                  </a>
                  <download-excel
                    :title="title"
                    v-else
                    class="btn btn-success"
                    :data="documents_excel"
                    :fields="excel_fields"
                    worksheet="Vessels"
                    name="Vessel.xls"
                    >Download Excel
                  </download-excel>
                </div>
              </div>
            </div>
            <br />
            <!-- End Export to Excel -->
            <div class="table-responsive">
              <table id="dataTableExample" class="table table-hover">
                <thead>
                  <tr>
                    <th>Sr No</th>
                    <th>Vessel Name</th>
                    <th>Category</th>
                    <th>Title</th>
                    <th>Edited By</th>
                    <th>Revision</th>
                    <th>Edition</th>
                    <th>Action</th>
                  </tr>
                </thead>
                <tbody>
                  <!-- Table Loader -->
                  <loading-table
                    :isLoading="isLoading"
                    cols="8
                        "
                  ></loading-table>
                  <!-- If No Data Received-->
                  <tr v-if="documents.length == 0">
                    <td colspan="8" class="text-center" style="color: grey">
                      No Data Found
                    </td>
                  </tr>
                  <!-- If data Received -->
                  <tr
                    v-for="(document, at) in documents"
                    :key="`document${at}`"
                  >
                    <td>{{ serialNoStarting + at + 1 }}</td>
                    <td>{{ document.vessel.vessel_name }}</td>
                    <td>
                      {{ document.category.name }}
                    </td>
                    <td>
                      {{ document.title }}
                    </td>
                    <td>{{ document.edited ? document.edited.name : "" }}</td>
                    <td>{{ document.revision }}</td>
                    <td>{{ document.edition }}</td>

                    <td>
                      <div>
                        <router-link
                          :to="`/document-management/new-documents/${document.id}`"
                          tag="button"
                          class="btn btn-primary btn-sm"
                          >Edit</router-link
                        >
                        &nbsp; &nbsp;
                        <button
                          class="btn btn-danger btn-sm"
                          @click="delete_data(document.id)"
                        >
                          Delete
                        </button>
                      </div>
                    </td>
                  </tr>
                </tbody>
              </table>
              <!-- /Table -->
            </div>
            <pagination :count="count" @submit="getData"></pagination>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- partial -->
</template>

<script type="text/javascript">
import axios from "axios";

export default {
  name: "document",
  data() {
    return {
      documents: [],
      count: 0,
      serialNoStarting: 1,
      isLoading: false,
      isExcelloading: false,
      searchData: "",
      documents_excel: [],
      excel_fields: {
        "Sr No": "sr_no",
        "Vessel Name": "vessel_name",
        Category: "category",
        Title: "title",
        "Edited by": "edited",
        Revision: "revision",
        Edition: "edition",
      },
      Exportdocuments: [],
    };
  },
  mounted() {
    this.getData();
  },
  methods: {
    // async getData() {
    async getData(page = 1) {
      this.isLoading = true;
      let documents = await axios.get(
        `/documents?page=${page}&rowsPerPage=${this.rowsPerPage}`
      );
      this.documents = documents.data.data;
      this.count = documents.data.count;
      this.serialNoStarting = (page - 1) * this.rowsPerPage;
      this.isLoading = false;
    },
    async search() {
      this.isLoading = true;
      let documents = await axios.get(`/documents?search=${this.searchData}`);
      this.documents = documents.data.data;
      this.count = documents.data.count;
      this.isLoading = false;
    },
    async exportToExcel() {
      this.isExcelloading = true;
      this.title = "Vessel Data";
      this.documents_excel = [];
      let Exportdocuments = [];
      Exportdocuments = await axios.get(`/documents`);
      this.Exportdocuments = Exportdocuments.data.data;
      let sr_no = 1;
      this.Exportdocuments.forEach((document) => {
        this.documents_excel.push({
          sr_no: sr_no,
          vessel_name: document.vessel_name ? document.vessel_name : "",
          category: document.document.category ? document.category.name : "",
          title: document.title ? document.title.name : "",
          edited: document.edited ? document.edited.name : "",
          revision: document.revision ? document.revision : "",
          edition: document.edition ? document.edition : "",
        });
        sr_no++;
      });
      this.isExcelloading = false;
    },
    async delete_data(id) {
      let check = confirm("Are you sure you want to delete the data");
      if (check) {
        try {
          this.isLoading = true;
          await axios.post(`delete?id=${id}&table_name=documents`);
          this.isLoading = false;
          this.getData();
        } catch (e) {
          this.isLoading = false;
        }
      }
    },
  },
};
</script>
